document.addEventListener("DOMContentLoaded", function () {

  const currentPath   = window.location.pathname;
  const currentSearch = window.location.search;

  /* ✅ TRUE BASE COLLECTION URL */
  const baseUrl = window.location.pathname
    .split('/')
    .slice(0, 3)
    .join('/');

  /* ==============================
     1️⃣ SET ACTIVE STATE (ON LOAD)
     ============================== */

  document.querySelectorAll(
    ".tps-rtw-filter-item-list .custom-filter-item"
  ).forEach(function (item) {

    const filterValue = item.getAttribute("data-filter");
    if (!filterValue) return;

    let isActive = false;

    /* 🔹 FACET / METAFIELD FILTER */
    if (
      filterValue.startsWith("filter.p.m.custom") &&
      currentSearch.includes(filterValue)
    ) {
      isActive = true;
    }

    /* 🔹 TAG FILTER */
    if (
      !filterValue.startsWith("filter.p.m.custom") &&
      currentPath.includes(filterValue)
    ) {
      isActive = true;
    }

    item.classList.toggle("active", isActive);
  });

  /* ==============================
     2️⃣ CLICK TOGGLE LOGIC
     ============================== */

  document.querySelectorAll(
    ".tps-rtw-filter-item-list .custom-filter-item a"
  ).forEach(function (link) {

    link.addEventListener("click", function (e) {

      const li = this.closest(".custom-filter-item");
      if (!li) return;

      const isActive = li.classList.contains("active");

      /* 🔁 DESELECT (ACTIVE → BASE COLLECTION) */
      if (isActive) {
        e.preventDefault();
        li.classList.remove("active");
        window.location.href = baseUrl;
        return;
      }

      /* ✅ SELECT (CLEAR OTHERS, ALLOW NAVIGATION) */
      document.querySelectorAll(
        ".tps-rtw-filter-item-list .custom-filter-item.active"
      ).forEach(el => el.classList.remove("active"));

      // allow normal navigation
    });

  });

});

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".tps_custom_filter_btn").forEach(function (link) {
    link.addEventListener("click", function (e) {

      const li = this.closest("li");
      const filterset = this.closest("filterset");
      if (!li || !filterset) return;

      const isActive = li.classList.contains("active");
      const baseUrl =
        filterset.dataset.baseUrl || "{{ collection.url }}";

      /* 🔁 DESELECT */
      if (isActive) {
        e.preventDefault();
        li.classList.remove("active");
        window.location.href = baseUrl;
        return;
      }

      /* ✅ SELECT */
      const ul = li.closest("ul");
      if (!ul) return;

      ul.querySelectorAll("li").forEach(item =>
        item.classList.remove("active")
      );

      li.classList.add("active");
      // allow normal navigation
    });
  });

});

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 991) return;

  const activeItem = document.querySelector(
    ".tps-custom-filter-set filterset ul li.active"
  );

  if (activeItem) {
    activeItem.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    });
  }

});

/* Multiselector filter code start*/
document.addEventListener('click', function(e) {

  const removeLink = e.target.closest('facet-remove a');
  if (!removeLink) return;

  // Wait for Shopify AJAX to update URL
  setTimeout(function() {

    const urlParams = new URLSearchParams(window.location.search);
    const checkboxes = document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]');

    checkboxes.forEach(function(cb) {
      const values = urlParams.getAll(cb.name);
      cb.checked = values.includes(cb.value);
    });

  }, 300);

});
document.addEventListener('DOMContentLoaded', function () {
  const resetBtn = document.querySelector('.custom-reset-filters');

  if (!resetBtn) return;

  resetBtn.addEventListener('click', function (e) {
    e.preventDefault();

    if (resetBtn.classList.contains('is-loading')) return;
    resetBtn.classList.add('is-loading');

    try {
      // ✅ Reset Shopify filters
      FacetFiltersForm.searchParamsPrev = '';
      FacetFiltersForm.renderPage('');

      history.pushState({}, '', window.location.pathname);

      // 🔥 IMPORTANT: Reset your price slider manually
      setTimeout(function(){

        const sliderEl = document.querySelector("#tps-price-slider");
        if(!sliderEl) return;

        const minInput = document.querySelector("#tps-filter-min");
        const maxInput = document.querySelector("#tps-filter-max");

        if(!minInput || !maxInput) return;

        const rangeMax = parseInt(sliderEl.dataset.rangeMax) || 0;

        // ✅ Reset inputs
        minInput.value = "$0";
        maxInput.value = "$" + rangeMax;

        // ✅ Remove filter params
        minInput.removeAttribute("name");
        maxInput.removeAttribute("name");

        // ✅ Reset slider UI
        const slider = $("#tps-price-slider");
        if(slider.hasClass("ui-slider")){
          slider.slider("values",[0,rangeMax]);
        }

        // ✅ Allow re-init (important for your observer)
        sliderEl.classList.remove("slider-initialized");

        priceFilterChanged = false;

        
        //  CARAT RESET START       

        // Clear stored values
        // localStorage.removeItem('carat_min');
        // localStorage.removeItem('carat_max');
        const handle = window.collectionHandle;
        localStorage.removeItem(handle ? 'carat_min_' + handle : 'carat_min_global');
        localStorage.removeItem(handle ? 'carat_max_' + handle : 'carat_max_global');

        const caratSlider = $("#carat-slider");

        if (caratSlider.length && caratSlider.hasClass("ui-slider")) {
          const min = caratSlider.slider("option", "min");
          const max = caratSlider.slider("option", "max");

          // ✅ Reset slider values
          caratSlider.slider("values", [min, max]);

          // ✅ Reset inputs
          const caratMinInput = document.querySelector("#carat-min");
          const caratMaxInput = document.querySelector("#carat-max");

          // if (caratMinInput && caratMaxInput) {
          //   caratMinInput.value = min.toFixed(2);
          //   caratMaxInput.value = max.toFixed(2);
          // }
          function formatCarat(val) {
            // Handle scaled values like 108 → 1.08
            if (val > 50) val = val / 100;

            return val.toFixed(2) + 'ct';
          }

          if (caratMinInput && caratMaxInput) {
            caratMinInput.value = formatCarat(min);
            caratMaxInput.value = formatCarat(max);
          }

        }

        // ✅ Show all products again
        $('.product-card').show();

        // ✅ Update count
        if (typeof updateProductCount === "function") {
          updateProductCount();
        }

        // ✅ Remove applied UI
        document.querySelectorAll('.carat-applied').forEach(el => el.remove());
        //  CARAT RESET END

      }, 300); // delay for Shopify render

    } catch (error) {
      console.error('Custom Reset Error:', error);
    } finally {
      setTimeout(() => {
        resetBtn.classList.remove('is-loading');
      }, 500);
    }

    const popup = document.getElementById('reset-module');
    if (popup) popup.style.display = 'none';
    
  });
});
document.addEventListener('click', function (e) {
  const popup = document.getElementById('reset-module');
  const popupInner = document.querySelector('.tps-reset-filter-confirm-popup-div');
  const triggerBtn = document.querySelector('.tps-reset-popup');

  if (!popup || popup.style.display !== 'block') return;

  // If click is NOT inside popup OR trigger button
  if (
    !popupInner.contains(e.target) &&
    !triggerBtn.contains(e.target)
  ) {
    popup.style.display = 'none';
  }
});